import { EndCustomerService } from 'src/app/services/end-customer.service';
import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { OemService } from 'src/app/services/oem/oem.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-hospitals',
  templateUrl: './hospitals.component.html',
  styleUrls: ['./hospitals.component.scss']
})
export class HospitalsComponent implements OnInit {

  itemsPerPage = 15;
  hoveredIndex: any;
  hospitals: any[] = [];
  filteredData = this.hospitals;
  originalHospitalsData: any[] = []
  paginatedItems: any[] = [];
  noData: boolean = false;
  selectedHealth: string = 'Hospitals';
  doctor: string = '';
  hospital: string = '';
  lab: string = '';
  clinic: string = '';
  screenSize: any;
  loading: boolean = false;
  currentPage: any=1 ;
  @ViewChildren('doctorDetailElements') doctorDetailElements: QueryList<ElementRef> | undefined;
  @ViewChildren('doctorNameElements') doctorNameElements: QueryList<ElementRef> | undefined;

  constructor(
    private endCustomerService: EndCustomerService,
    private oemService: OemService,
    private router: Router,
    private route: ActivatedRoute,
    private masterDataService: MasterDataService,
    private spinner: SpinnerService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.screenSize = { width: window.innerWidth, height: window.innerHeight };
  
    const state = window.history.state;
    this.selectedHealth = state && state['health'] ? state['health'] : 'Hospitals';
    const storedPage = sessionStorage.getItem('currentPage');
    if(storedPage === '0' ){
            this.currentPage = 1;
    }
    this.hospitals = [];
    this.filteredData = [];
    this.paginatedItems = [];
    this.noData = false;
  
    this.checkScreenSize();
    const url = this.router.url;
    if (url.includes('doctors')) {
      this.selectedHealth = 'Doctors';
    } else if (url.includes('hospitals')) {
      this.selectedHealth = 'Hospitals';
    } else if (url.includes('labs')) {
      this.selectedHealth = 'Labs';
    } else if (url.includes('clinics')) {
      this.selectedHealth = 'Clinics';
    }
     
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && event.id === 1) {
        const storageKey = `${this.selectedHealth}_filters`;
        sessionStorage.removeItem(storageKey);
        // this.currentPage=sessionStorage.getItem('currentPage');
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { page: this.currentPage },
          queryParamsHandling: 'merge',
          replaceUrl: true
        }).then(() => {
          this.getAccountTypes();
        });
      } else if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
        this.route.queryParams.subscribe((params: Params) => {

          const filterState = this.extractFiltersFromParams(params);
          if (filterState) {
            const storageKey = `${this.selectedHealth}_filters`;
            sessionStorage.setItem(storageKey, JSON.stringify(filterState));
          }
          this.getAccountTypes();
        });
      }
    });
  
    if (this.router.getCurrentNavigation()?.id !== 1) {
      this.route.queryParams.subscribe((params: Params) => {
     
        const filterState = this.extractFiltersFromParams(params);
        if (filterState) {
          const storageKey = `${this.selectedHealth}_filters`;
          sessionStorage.setItem(storageKey, JSON.stringify(filterState));
        }
        this.getAccountTypes();
      });
    }
  }
 private extractFiltersFromParams(params: any): any {
  const filterState: any = {};
  if (params.keywords) filterState.keywords = params.keywords.split(',');
  if (params.countries) filterState.countries = params.countries.split(',');
  if (params.states) filterState.states = params.states.split(',');
  if (params.cities) filterState.cities = params.cities.split(',');
  if (params.zipCode) filterState.zipCode = params.zipCode;
  if (params.yearFrom) filterState.yearFrom = Number(params.yearFrom);
  if (params.yearTo) filterState.yearTo = Number(params.yearTo);
  if (params.specializations) filterState.specializations = params.specializations.split(',');
  return Object.keys(filterState).length > 0 ? filterState : null;
}

  private applyFiltersFromState(filterState: any): any[] {
    let filtered = this.originalHospitalsData;
    const currentYear = new Date().getFullYear();
  
    if (filterState.keywords && filterState.keywords.length > 0) {
      const lowerCaseKeywords = filterState.keywords.map((keyword: string) => keyword.toLowerCase());
      filtered = filtered.filter(item =>
        (item.name && lowerCaseKeywords.some((keyword: any) => item.name.toLowerCase().includes(keyword))) ||
        (item.organization && lowerCaseKeywords.some((keyword: any) => item.organization.toLowerCase().includes(keyword))) ||
        (item.organization && lowerCaseKeywords.some((keyword: any) => item.name.toLowerCase().includes(keyword))) ||
        (item.country && lowerCaseKeywords.some((keyword: any) => item.country.toLowerCase().includes(keyword))) ||
        (item.state && lowerCaseKeywords.some((keyword: any) => item.state.toLowerCase().includes(keyword))) ||
        (item.city && lowerCaseKeywords.some((keyword: any) => item.city.toLowerCase().includes(keyword))) ||
        (item?.specialityName && item?.specialityName.some((speciality: string) =>
          lowerCaseKeywords?.some((keyword: string) => speciality?.toLowerCase().includes(keyword))))
      );
    }
  
    if (filterState.countries && filterState.countries.length > 0) {
      filtered = filtered.filter(item =>
        item.country && filterState.countries.some((country: string) => item.country.toLowerCase() === country.toLowerCase())
      );
    }
  
    if (filterState.states && filterState.states.length > 0) {
      filtered = filtered.filter(item =>
        item.state && filterState.states.some((state: string) => item.state.toLowerCase() === state.toLowerCase())
      );
    }
  
    if (filterState.cities && filterState.cities.length > 0) {
      filtered = filtered.filter(item =>
        item.city && filterState.cities.some((city: string) => item.city.toLowerCase() === city.toLowerCase())
      );
    }
  
    if (filterState.zipCode && filterState.zipCode.length > 0) {
      filtered = filtered.filter(item =>
        item.zipCode && String(item.zipCode) === String(filterState.zipCode));
    }
  
    if (filterState.yearFrom >= 0 && filterState.yearTo > filterState.yearFrom) {
      filtered = filtered.filter(item => {
        if (filterState.yearFrom === 0 && item.expertSince === null) {
          return true;
        }
        if (item.expertSince !== null) {
          const yearsInMarket = currentYear - item.expertSince;
          return yearsInMarket >= filterState.yearFrom && yearsInMarket <= filterState.yearTo;
        }
        return false;
      });
    }
  
    if (filterState.yearFrom === filterState.yearTo && filterState.yearFrom > 0) {
      filtered = filtered.filter(item => {
        if (item.expertSince !== null) {
          const yearsInMarket = currentYear - item.expertSince;
          return yearsInMarket === filterState.yearFrom;
        }
        return false;
      });
    }
  
    if (filterState.specializations && filterState.specializations.length > 0) {
      filtered = filtered.filter(item =>
        item?.specialityName &&
        item.specialityName.some((speciality: string) =>
          filterState.specializations.includes(speciality)
        )
      );
    }
  
    return filtered;
  }

  setPageFromQuery(pageNumber: number) {
    const startIndex = (pageNumber-1 ) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedItems = this.hospitals.slice(startIndex, endIndex);
  }

  viewHospitalsProfile(hospital: any): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const storageKey = `${this.selectedHealth}_filters`;
    const savedFilters = sessionStorage.getItem(storageKey);
    const navigationExtras = {
      state: {
        health: this.selectedHealth,
        filters: savedFilters ? JSON.parse(savedFilters) : null
      }
    };
  
    if (this.selectedHealth === 'Doctors') {
      this.router.navigate([`doctor-info`, hospital.id], navigationExtras);
    } else if (this.selectedHealth === 'Hospitals') {
      this.router.navigate([`hospitalDetails`, hospital.id], navigationExtras);
    } else if (this.selectedHealth === 'Labs') {
      this.router.navigate([`labs`, hospital.id], navigationExtras);
    } else if (this.selectedHealth === 'Clinics') {
      this.router.navigate([`clinics`, hospital.id], navigationExtras);
    }
  }

  getAccountTypes() {
    this.masterDataService.getOnboardingAllAccountTypes().subscribe((res) => {
      res.data.map((data: any) => {
        if (data.name === 'Doctor') {
          this.doctor = data.id;
        } else if (data.name === 'Hospital') {
          this.hospital = data.id;
        } else if (data.name === 'Laboratory') {
          this.lab = data.id;
        } else if (data.name === 'Clinics') {
          this.clinic = data.id;
        }
      })
      this.getAllEntityList(this.selectedHealth);
    })
  }

  getAllEntityList(health: string): void {
    let accountId;
    switch (health) {
      case 'Doctors':
        accountId = this.doctor;
        break;
      case 'Hospitals':
        accountId = this.hospital;
        break;
      case 'Labs':
        accountId = this.lab;
        break;
      case 'Clinics':
        accountId = this.clinic;
        break;
    }
    const obj = { accountId: [accountId] };
  
    const applySavedFilters = () => {
      const storageKey = `${this.selectedHealth}_filters`;
      const savedFilters = sessionStorage.getItem(storageKey);
      if (savedFilters) {
        const filterState = JSON.parse(savedFilters);
        const filtered = this.applyFiltersFromState(filterState);
        this.hospitals = filtered;
        this.filteredData = filtered;
        this.noData = filtered.length === 0;
        this.paginatedItems = filtered.slice(0, this.itemsPerPage);
      } else {
        this.hospitals = this.originalHospitalsData;
        this.filteredData = this.originalHospitalsData;
        this.noData = this.originalHospitalsData.length === 0;
        this.paginatedItems = this.originalHospitalsData.slice(0, this.itemsPerPage);
      }
      this.loading = false;
      this.spinner.hideSpinner();
    };
  
    if (health === 'Doctors') {
      this.spinner.showSpinner();
      this.loading = true;
      this.endCustomerService.doctorsDetails(obj, 1000, 0).subscribe((res: any) => {
        this.originalHospitalsData = res.data.sort((a: any, b: any) => {
          if (a.logo && !b.logo) return -1;
          if (!b.logo && a.logo) return 1;
          return 0;
        });
        this.itemsPerPage = 16;
        this.checkScreenSize();
        applySavedFilters();
      });
    } else if (health === 'Hospitals') {
      this.spinner.showSpinner();
      this.loading = true;
      this.endCustomerService.hospitalsDetails(obj, 0, 1000).subscribe((res: any) => {
        this.originalHospitalsData = res.data.sort((a: any, b: any) => {
          if (a.logo && !b.logo) return -1;
          if (!b.logo && a.logo) return 1;
          return 0;
        });
        applySavedFilters();
      });
    } else if (health === 'Labs') {
      this.spinner.showSpinner();
      this.loading = true;
      this.endCustomerService.labsDetails(obj, 0, 1000).subscribe((res: any) => {
        this.originalHospitalsData = res.data.sort((a: any, b: any) => {
          if (a.logo && !b.logo) return -1;
          if (!b.logo && a.logo) return 1;
          return 0;
        });
        applySavedFilters();
      });
    } else if (health === 'Clinics') {
      this.spinner.showSpinner();
      this.loading = true;
      this.endCustomerService.clinicsDetails(obj, 0, 1000).subscribe((res: any) => {
        this.originalHospitalsData = res.data.sort((a: any, b: any) => {
          if (a.logo && !b.logo) return -1;
          if (!b.logo && a.logo) return 1;
          return 0;
        });
        applySavedFilters();
      });
    }
  }
  onPageChanged(paginatedData: any[], pageNumber?: number): void {  
    const currentPage = (pageNumber ?? 0) + 1;
    this.currentPage = currentPage; 
    this.paginatedItems = paginatedData;  
    sessionStorage.setItem('currentPage', this.currentPage.toString());       
    this.topOfPage();
  }
  
  topOfPage(){
    const topOfPage = document.querySelector('app-root');
    if (topOfPage) {
        topOfPage.scrollIntoView({ behavior: 'smooth' });
      } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
      }
  }

  onFilteredData(filtered: any[]): void {
    this.filteredData = filtered;
    this.hospitals = filtered.length > 0 ? filtered : this.originalHospitalsData;
    this.noData = filtered.length === 0;
    let  tempCurrentPage= sessionStorage.getItem('currentPage');
    if(tempCurrentPage==='0'){
      this.currentPage = 1;
    }
    else{
       this.currentPage=tempCurrentPage
    }
   
    this.paginatedItems = this.hospitals.slice(0, this.itemsPerPage);
    this.loading = this.paginatedItems.length > 0;
  }

  getInitial(name: string): string {
    if (!name) return '';
    const cleanedName = name.replace(/^Dr\.?\s+/, '');
    return cleanedName.charAt(0).toUpperCase();
  }

  splitName(name: string) {
    if (!name) return [];
    return name.split(' ');
  }

  updatedDoctorName(name: string) {
    const nameArray = this.splitName(name);
    if (nameArray.length < 2) return name;
    return nameArray[0] + ' ' + nameArray[1];
  }

  checkScreenSize() {
    const resizeWidth = window.innerWidth;
    if(this.selectedHealth === 'Doctors'){
      if (resizeWidth > 1550) {
        this.itemsPerPage = 16;
      }
      else if (resizeWidth >= 1300 && resizeWidth < 1550) {
        this.itemsPerPage = 15;
      }
      else if (resizeWidth >= 1190 && resizeWidth < 1300) {
        this.itemsPerPage = 12;
      } else {
        this.itemsPerPage = 10;
      }
    }
    else{
      if (resizeWidth > 1550) {
        this.itemsPerPage = 15;
      }
      else if (resizeWidth >= 1300 && resizeWidth < 1550) {
        this.itemsPerPage = 15;
      }
      else if (resizeWidth >= 1190 && resizeWidth < 1300) {
        this.itemsPerPage = 12;
      }
    }
  }

  checkDoctorImageType(image: string) {
    if (!image) return false;
    const imageType = image.split('.').pop()?.toLowerCase();
    return imageType === 'png' || imageType === 'svg';
  }

  ngAfterViewChecked() {
    this.changeHeightOfTheDoctorCard(this.doctorNameElements);
    this.changeHeightOfTheDoctorCard(this.doctorDetailElements);
  }

  changeHeightOfTheDoctorCard(doctorElement: any) {
    if (doctorElement) {
      let maxHeight = 0;
      doctorElement.toArray().forEach((element: any) => {
        const height = element.nativeElement.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      doctorElement.toArray().forEach((element: any) => {
        element.nativeElement.style.height = `${maxHeight}px`;
      });
    }
  }

  ngAfterViewInit() {
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  ngDestroy() {
    window.removeEventListener('resize', () => { });
  }
}